import _ from 'lodash';
import defaultOnErrorHandler from './default-on-error-handler';
import debounceAction from './debounce-action';
import shareTo from '../services/wire/share-service';

const validMedium = ['wire-page-share', 'publisher-prompt', 'scheduled-prompt'];

const socialMedia = ['Twitter', 'Facebook', 'Linked_In'];

function clickToShare({ wireId, source, medium }) {
  const validSources = _.map(socialMedia, _.toLower);
  if (!_.includes(validSources, source) || !_.includes(validMedium, medium)) {
    return;
  }

  const action = debounceAction({
    getCurrentValue: () => Date.now(),
    actionPromise: () => shareTo(wireId, source, medium),
    onNext: d => _.get(d, 'data.share_url') && window.open(d.data.share_url, '_blank'),
    onError: e => defaultOnErrorHandler(e, 'Error sharing wire'),
  });
  action();
}

export { clickToShare, socialMedia };
